/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_EventsInputs */

const en_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Events`)
};

const fr_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller les événements`)
};

const de_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse einfügen`)
};

const it_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla eventi`)
};

const ru_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить события`)
};

const es_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar eventos`)
};

const zh_cn2_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴事件`)
};

const ja_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを貼り付ける`)
};

const hi_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट इवेंट्स`)
};

const pt_pt2_paste_events = /** @type {(inputs: Paste_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar eventos`)
};

/**
* | output |
* | --- |
* | "Paste Events" |
*
* @param {Paste_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_events = /** @type {((inputs?: Paste_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_events(inputs)
	if (locale === "de") return de_paste_events(inputs)
	if (locale === "it") return it_paste_events(inputs)
	if (locale === "ru") return ru_paste_events(inputs)
	if (locale === "es") return es_paste_events(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_events(inputs)
	if (locale === "ja") return ja_paste_events(inputs)
	if (locale === "hi") return hi_paste_events(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_events(inputs)
	return en_paste_events(inputs)
});